import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import TIMEZONES from "../time-selector/timezones";
import {TimezoneService} from "../../Services/timezone/timezone.service";
import {Timezone} from "../../Models/Timezone";

@Component({
  selector: 'app-timezone-selector',
  templateUrl: './timezone-selector.component.html',
  styleUrls: ['./timezone-selector.component.scss']
})
export class TimezoneSelectorComponent implements OnInit {
  title = "Time Zone";

  timezones = TIMEZONES;
  timezoneService: TimezoneService;
  @Output() close = new EventEmitter();

  selectTimezone(timezone) {
    window['appointmentTimezone'] = timezone.time;
    this.timezoneService.timezone = timezone;
    this.timezoneService.setZoneId();
    this.timezoneService.setRegion();
    this.close.emit(timezone);
  }

  constructor(timezone: TimezoneService) {
    this.timezoneService = timezone;
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// /app/src/app/Components/timezone-selector/timezone-selector.component.ts